import '../vendor/clickMenu.js';

export const setupFooterNav = () => {
  $('.footer-nav').clickMenu({ menutype: 'accordion', expanders: true });
};
